function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/delete
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import DeleteCommand from './deletecommand';
import DeleteObserver from './deleteobserver';
import env from '@ckeditor/ckeditor5-utils/src/env';
/**
 * The delete and backspace feature. Handles the <kbd>Delete</kbd> and <kbd>Backspace</kbd> keys in the editor.
 *
 * @extends module:core/plugin~Plugin
 */

var Delete = /*#__PURE__*/function (_Plugin) {
  _inherits(Delete, _Plugin);

  var _super = _createSuper(Delete);

  function Delete() {
    _classCallCheck(this, Delete);

    return _super.apply(this, arguments);
  }

  _createClass(Delete, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var view = editor.editing.view;
      var viewDocument = view.document;
      view.addObserver(DeleteObserver);
      editor.commands.add('forwardDelete', new DeleteCommand(editor, 'forward'));
      editor.commands.add('delete', new DeleteCommand(editor, 'backward'));
      this.listenTo(viewDocument, 'delete', function (evt, data) {
        var deleteCommandParams = {
          unit: data.unit,
          sequence: data.sequence
        }; // If a specific (view) selection to remove was set, convert it to a model selection and set as a parameter for `DeleteCommand`.

        if (data.selectionToRemove) {
          var modelSelection = editor.model.createSelection();
          var ranges = [];

          var _iterator = _createForOfIteratorHelper(data.selectionToRemove.getRanges()),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var viewRange = _step.value;
              ranges.push(editor.editing.mapper.toModelRange(viewRange));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          modelSelection.setTo(ranges);
          deleteCommandParams.selection = modelSelection;
        }

        editor.execute(data.direction == 'forward' ? 'forwardDelete' : 'delete', deleteCommandParams);
        data.preventDefault();
        view.scrollToTheSelection();
      }); // Android IMEs have a quirk - they change DOM selection after the input changes were performed by the browser.
      // This happens on `keyup` event. Android doesn't know anything about our deletion and selection handling. Even if the selection
      // was changed during input events, IME remembers the position where the selection "should" be placed and moves it there.
      //
      // To prevent incorrect selection, we save the selection after deleting here and then re-set it on `keyup`. This has to be done
      // on DOM selection level, because on `keyup` the model selection is still the same as it was just after deletion, so it
      // wouldn't be changed and the fix would do nothing.
      //

      if (env.isAndroid) {
        var domSelectionAfterDeletion = null;
        this.listenTo(viewDocument, 'delete', function (evt, data) {
          var domSelection = data.domTarget.ownerDocument.defaultView.getSelection();
          domSelectionAfterDeletion = {
            anchorNode: domSelection.anchorNode,
            anchorOffset: domSelection.anchorOffset,
            focusNode: domSelection.focusNode,
            focusOffset: domSelection.focusOffset
          };
        }, {
          priority: 'lowest'
        });
        this.listenTo(viewDocument, 'keyup', function (evt, data) {
          if (domSelectionAfterDeletion) {
            var domSelection = data.domTarget.ownerDocument.defaultView.getSelection();
            domSelection.collapse(domSelectionAfterDeletion.anchorNode, domSelectionAfterDeletion.anchorOffset);
            domSelection.extend(domSelectionAfterDeletion.focusNode, domSelectionAfterDeletion.focusOffset);
            domSelectionAfterDeletion = null;
          }
        });
      }
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'Delete';
    }
  }]);

  return Delete;
}(Plugin);

export { Delete as default };